<form [formGroup]="filterFormGroup">
    <div class="filter-elements">

        <!-- NetzbetreiberID -->
        @if (westnetzUserOrWestnetzAdmin) {
            <mat-form-field data-qa="kaskade-netzzuordnungen-filter">
                <mat-label>Netzbetreiber-ID</mat-label>
                <input matInput
                       name="stadtwerkeId"
                       [matAutocomplete]="stadtwerkeId"
                       data-qa="filter-stadtwerkeId"
                       formControlName="stadtwerkeId">
                <mat-icon matSuffix svgIcon="innogy_picto_magnifier"></mat-icon>
                <mat-autocomplete #stadtwerkeId="matAutocomplete"
                                  panelWidth="200">
                    @for (stadtwerkeId of filteredStadtwerkeId$ | async; track stadtwerkeId) {
                        <mat-option [value]="stadtwerkeId">
                            {{ stadtwerkeId }}
                        </mat-option>
                    }
                </mat-autocomplete>
            </mat-form-field>
        }

        <!-- Netzbetreibername -->
        @if (westnetzUserOrWestnetzAdmin) {
            <mat-form-field data-qa="kaskade-netzzuordnungen-filter">
                <mat-label>Netzbetreiber</mat-label>
                <input matInput
                       name="netzbetreiberName"
                       [matAutocomplete]="netzbetreiberName"
                       data-qa="filter-netzbetreiberName"
                       formControlName="netzbetreiberName">
                <mat-icon matSuffix svgIcon="innogy_picto_magnifier"></mat-icon>
                <mat-autocomplete #netzbetreiberName="matAutocomplete"
                                  panelWidth="200">
                    @for (netzbetreiberName of filteredNetzbetreiberName$ | async; track netzbetreiberName) {
                        <mat-option [value]="netzbetreiberName">
                            {{ netzbetreiberName }}
                        </mat-option>
                    }
                </mat-autocomplete>
            </mat-form-field>
        }

        <!-- Teilgebiet -->
        @if (westnetzUserOrWestnetzAdmin) {
            <mat-form-field data-qa="kaskade-netzzuordnungen-filter">
                <mat-label>Teilgebiet</mat-label>
                <input matInput
                       name="netzbetreiberTeilgebiet"
                       [matAutocomplete]="netzbetreiberTeilgebiet"
                       data-qa="filter-netzbetreiberTeilgebiet"
                       formControlName="netzbetreiberTeilgebiet">
                <mat-icon matSuffix svgIcon="innogy_picto_magnifier"></mat-icon>
                <mat-autocomplete #netzbetreiberTeilgebiet="matAutocomplete" panelWidth="200">
                    @for (netzbetreiberTeilgebiet of filteredNetzbetreiberTeilgebiet$ | async; track netzbetreiberTeilgebiet) {
                        <mat-option [value]="netzbetreiberTeilgebiet">
                            {{ netzbetreiberTeilgebiet }}
                        </mat-option>
                    }
                </mat-autocomplete>
            </mat-form-field>
        }


        <!-- Netzgruppe -->
        <mat-form-field data-qa="kaskade-netzzuordnungen-filter">
            <mat-label>Netzgruppe</mat-label>
            <input matInput
                   name="netzgruppe"
                   [matAutocomplete]="netzgruppe"
                   data-qa="filter-netzgruppe"
                   formControlName="netzgruppe">
            <mat-icon matSuffix svgIcon="innogy_picto_magnifier"></mat-icon>

            <mat-autocomplete #netzgruppe="matAutocomplete" panelWidth="200">
                @for (netzgruppe of filteredNetzgruppe$ | async; track netzgruppe) {
                    <mat-option [value]="netzgruppe">
                        {{ netzgruppe }}
                    </mat-option>
                }
            </mat-autocomplete>
        </mat-form-field>


        <!-- Ortsname -->
        <mat-form-field data-qa="kaskade-netzzuordnungen-filter">
            <mat-label>Ortsname</mat-label>
            <input matInput
                   name="ortsname"
                   [matAutocomplete]="ortsname"
                   data-qa="filter-ortsname"
                   formControlName="ortsname">
            <mat-icon matSuffix svgIcon="innogy_picto_magnifier"></mat-icon>

            <mat-autocomplete #ortsname="matAutocomplete"
                              panelWidth="200">
                @for (ortsname of filteredOrtsnamen$ | async; track ortsname) {
                    <mat-option [value]="ortsname">
                        {{ ortsname }}
                    </mat-option>
                }
            </mat-autocomplete>
        </mat-form-field>

        <!-- Stationsname -->
        <mat-form-field data-qa="kaskade-netzzuordnungen-filter">
            <mat-label>Stationsname</mat-label>
            <input matInput
                   name="stationsname"
                   [matAutocomplete]="stationsname"
                   data-qa="filter-stationsname"
                   formControlName="stationsname">
            <mat-icon matSuffix svgIcon="innogy_picto_magnifier"></mat-icon>

            <mat-autocomplete #stationsname="matAutocomplete"
                              panelWidth="200">
                @for (stationsname of filteredStationsnamen$ | async; track stationsname) {
                    <mat-option [value]="stationsname">
                        {{ stationsname }}
                    </mat-option>
                }
            </mat-autocomplete>
        </mat-form-field>

        <!-- Trafo-, Feldname, SS -->
        <mat-form-field data-qa="kaskade-netzzuordnungen-filter">
            <mat-label>Trafo-, Feldname, SS</mat-label>
            <input matInput
                   name="trafoFeldName"
                   [matAutocomplete]="trafoFeldName"
                   data-qa="filter-trafofeldname"
                   formControlName="trafoFeldName">
            <mat-icon matSuffix svgIcon="innogy_picto_magnifier"></mat-icon>

            <mat-autocomplete #trafoFeldName="matAutocomplete"
                              panelWidth="200">
                @for (trafoFeldName of filteredTrafoFeldNamen$ | async; track trafoFeldName) {
                    <mat-option [value]="trafoFeldName">
                        {{ trafoFeldName }}
                    </mat-option>
                }
            </mat-autocomplete>
        </mat-form-field>

        <!-- UUID -->
        <mat-form-field data-qa="kaskade-netzzuordnungen-filter">
            <mat-label>UUID</mat-label>
            <input matInput
                   name="uuid"
                   [matAutocomplete]="uuid"
                   data-qa="filter-uuid"
                   formControlName="uuid">
            <mat-icon matSuffix svgIcon="innogy_picto_magnifier"></mat-icon>

            <mat-autocomplete #uuid="matAutocomplete"
                              panelWidth="200">
                @for (uuid of filteredUuid$ | async; track uuid) {
                    <mat-option [value]="uuid" data-qa="filter-uuid-option">
                        {{ uuid }}
                    </mat-option>
                }
            </mat-autocomplete>
        </mat-form-field>

        <!-- Date -->
        <mat-form-field data-qa="filter-uuidDatum">
            <mat-label>UUID-Datum</mat-label>
            <mat-date-range-input formGroupName="uuidDate" [rangePicker]="picker">
                <input matStartDate formControlName="start" placeholder="Start">
                <input matEndDate formControlName="end" placeholder="Ende">
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="picker">
                <mat-icon matDatepickerToggleIcon svgIcon="innogy_picto_calendar-date-year"></mat-icon>
            </mat-datepicker-toggle>
            <mat-date-range-picker #picker></mat-date-range-picker>
            <mat-icon matSuffix svgIcon="innogy_picto_magnifier"></mat-icon>
        </mat-form-field>

        <!-- Technischer Platz -->
        <mat-form-field data-qa="kaskade-netzzuordnungen-filter">
            <mat-label>Technischer Platz</mat-label>
            <input matInput
                   name="technischerPlatz"
                   [matAutocomplete]="technischerPlatz"
                   data-qa="filter-technischerplatz"
                   formControlName="technischerPlatz">
            <mat-icon matSuffix svgIcon="innogy_picto_magnifier"></mat-icon>

            <mat-autocomplete #technischerPlatz="matAutocomplete"
                              panelWidth="200">
                @for (technischerPlatz of filteredTechnischerPlatz$ | async; track technischerPlatz) {
                    <mat-option [value]="technischerPlatz">
                        {{ technischerPlatz }}
                    </mat-option>
                }
            </mat-autocomplete>
        </mat-form-field>

    </div>

    <div class="reset-button-container">
        <button id="resetFiltersButton" matButton="filled" type="reset" data-qa="resetFiltersButton">
            <mat-icon>autorenew</mat-icon>
            Zurücksetzen
        </button>
        <button id="exportCsvButton" matButton="outlined" data-qa="exportCsvButton"
                type="button"
                (click)="exportNetzzuordnungen()">
            <mat-icon>file_download</mat-icon>
            CSV exportieren
        </button>
    </div>
</form>

